import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { filter, take, map } from 'rxjs';

export const roleGuard: CanActivateFn = (_route, state) => {
  const permissionsService = inject(PermissionsService);
  const router = inject(Router);

  const pathOnly = state.url.split('?')[0];
  const targetRoute = '/' + pathOnly.split('/').filter(Boolean)[0];

  return permissionsService.permissionsReady$.pipe(
    filter(ready => ready),
    take(1),
    map(() => {
      if (!permissionsService.hasAccess(targetRoute)) {
        router.navigate(['/dashboard']);
        return false;
      }
      return true;
    })
  );
};
